module.exports = __webpack_public_path__ + "d409c9e3b7123844c74865f14d31d66a.png";